import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchPackageGroups(
    packing_house_id,
    packing_house_process_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_process/fetch_package_groups/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
    );
  },

  fetchPackagesFromStock(
    packing_house_id,
    packing_house_process_id,
    current_page,
    rows_per_page
  ) {
    return RequesterV1.get(
      `packing_house/production/palletized/${packing_house_id}/show_process/fetch_packages_from_stock/${packing_house_process_id}?current_page=${current_page}&rows_per_page=${rows_per_page}`
    );
  },
};
